import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ObjectService } from '../../../../shared/object.service';
import { Project } from '../../../../models/project';
import { RegionAttachable, WidgetMapRegion } from '../../../../models/widget';
import { PObject } from '../../../../models/object';

export abstract class EditorEntityListComponentBase {
  @Output() selected: EventEmitter<WidgetMapRegion> = new EventEmitter<WidgetMapRegion>();
  @Output() deleted: EventEmitter<WidgetMapRegion> = new EventEmitter<WidgetMapRegion>();
  @Output() drawing: EventEmitter<RegionAttachable> = new EventEmitter<RegionAttachable>();
  @Input() regions: WidgetMapRegion[];
  @Input() selectedRegion: WidgetMapRegion;

  hasRegion(entity: RegionAttachable) {
    const region = this.getRegion(entity);
    return !!region;
  }

  getRegion(entity: RegionAttachable) {
    return this.regions.find(region => {
      return region.entity && region.entity.getId() === entity.getId();
    });
  }

  doDelete(entity: RegionAttachable) {
    const region = this.getRegion(entity);
    if (region) {
      this.deleted.emit(region);
    }
  }

  doDraw(entity: RegionAttachable) {
    this.drawing.emit(entity);
  }

  doClick(entity: RegionAttachable) {
    const region = this.getRegion(entity);
    if (region) {
      this.selected.emit(region);
    }
  }
}

@Component({
  selector: 'cw-editor-object-list',
  templateUrl: './editor-object-list.component.html',
})

export class EditorObjectListComponent extends EditorEntityListComponentBase implements OnInit, OnChanges {
  @Input() project: Project;

  objects: PObject[];

  constructor(private objectService: ObjectService) {
    super();
  }

  ngOnInit() {
    this.objectService.get(this.project).subscribe(objects => {
      this.objects = objects;
    });
  }

  ngOnChanges() {

  }

  hasRegion(object: RegionAttachable) {
    const region = this.getRegion(object);
    return !!region;
  }

  getRegion(object: RegionAttachable) {
    return this.regions.find(region => {
      return region.entity && region.entity.getId() === object.getId();
    });
  }

  isSelected(object: PObject) {
    if (!this.selectedRegion) {
      return false;
    }
    const region = this.getRegion(object);
    return region && this.selectedRegion.tempId === region.tempId;
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-editor/editor-object-list/editor-object-list.component.ts